import {getFileNameAndExtension} from '@ey/utils';
import * as actions from '../../actions/actiontypes';
import {
	DocumentStatus,
	documentTabLayoutTabs,
	documentTypes,
	GAComponentDocumentStatus,
	HttpStatusCodes
} from '../../util/uiconstants';
import Utility from '../../util/utilityfunctions';
import initialstate from '../initialstate';
import {getFileExtension, getFileName} from '../../util/utils';

export default function documentListReducer(state = initialstate.documentList, action) {
	switch (action.type) {
		case actions.GET_DOCUMENT_LIST: {
			if (action.response) {
				let result;

				const filters = {...action.filters};
				delete filters.shared;

				// Normalized data
				let approvals;
				let clientApprovals;
				let tasks;
				let documentReviews;
				let childrenDocuments;
				let relatedCanvasForms;

				if (action.response.data && action.response.data.length > 0) {
					let data = {};
					if (action?.payload?.excludeDaasInprogressDocuments) {
						action.response.data = Utility.excludeDaasInprogressDocuments(action.response.data);
					}
					for (let i = 0; i < action.response.data.length; i++) {
						let document = {...action.response.data[i]};
						for (let i = 0; i < document.clientApprovals.length; i++) {
							if (typeof document.clientApprovals[i]?.clientSignoffJson === 'string') {
								let objectFromJson;
								try {
									/*turn lastName and firstName into LastName and FirstName*/
									let cleanedUp = document.clientApprovals[i].clientSignoffJson
										.replaceAll(/"firstName"/g, '"FirstName"')
										.replaceAll(/"lastName"/g, '"LastName"')
										.replaceAll(/"SignOffDate"/g, '"CreateDate"')
										.replaceAll(/"createDate"/g, '"CreateDate"')
										.replaceAll(/"userRole"/g, '"UserRole"');
									objectFromJson = JSON.parse(cleanedUp);
								} catch (error) {
									objectFromJson = undefined;
								}
								document.clientApprovals[i] = {
									clientSignOffJson: objectFromJson,
									id: document.clientApprovals[i].id
								};
							}
						}

						let signOffUsers = document.approvals;
						approvals = Utility.normalize(document.approvals, approvals);
						clientApprovals = Utility.normalize(document.clientApprovals, clientApprovals);
						childrenDocuments = Utility.normalize(document.childrenDocuments, childrenDocuments);
						relatedCanvasForms = Utility.normalize(document.relatedCanvasForms, relatedCanvasForms);

						tasks = Utility.normalize(document.tasks, tasks);

						let aresTaskId = document.tasks?.find((task) => task.isSystemAssociated)?.id;
						if (!aresTaskId) {
							aresTaskId = document.tasks?.[0]?.id;
						}

						document.documentTaskId = aresTaskId;
						documentReviews = Utility.normalize(document.documentReviews, documentReviews);

						document.filteredEntityIdGuid = action.filteredEntityIdGuid;
						document.approvals = document.approvals && document.approvals.map((approval) => approval?.id);
						document.clientApprovals =
							document.clientApprovals && document.clientApprovals.map((clientApproval) => clientApproval?.id);
						document.signOffUsers = signOffUsers;
						document.tasks = document.tasks && document.tasks.map((task) => task?.id);
						document.documentReviews =
							document.documentReviews && _.map(document.documentReviews, (documentReview) => documentReview?.id);
						document.childrenDocuments =
							document.childrenDocuments && document.childrenDocuments.map((chDoc) => chDoc.id);
						document.relatedCanvasForms = document.relatedCanvasForms?.map((relatedCanvasForm) => relatedCanvasForm.id);
						document.relatedTasksCount = document.tasks && document.tasks.length;
						document.isReturned =
							document.documentTypeId === documentTypes.RETURNEDDOCUMENT ||
							document.gaComponentDocumentStatusID === GAComponentDocumentStatus.Returned
								? true
								: false;
						document.isReadOnly =
							[
								documentTypes.PRIORYEAREVIDENCE,
								documentTypes.EXTERNALDOCUMENTS,
								documentTypes.AUTOMATIONHUBOUTPUT,
								documentTypes.AUTOMATIONHUBCLIENTOUTPUT,
								documentTypes.GROUPCOMPONENTINSTRUCTIONDOCUMENT,
								documentTypes.RETURNEDDOCUMENT
							].indexOf(document.documentTypeId) !== -1
								? true
								: false;

						data[action.response.data[i].id] = document;
					}

					if (action.parentName === 'CGTSendModal_') {
						result = {...state};
						// CGT Other Evidence section: document type 7
						let typedData = Object.values(data);
						typedData = typedData.filter((document) => document.documentTypeId === documentTypes.EVIDENCE);
						if (typedData.length > 0) {
							result = {
								...result,
								[`${action.parentName}evidence`]: {
									...result[`${action.parentName}evidence`],
									filters,
									filterKey: `${action.parentName}evidence`,
									response: {
										data: typedData,
										page: action.response.page,
										pages: action.response.pages,
										totalEntityCount: action.response.totalEntityCount
									},
									documents: {
										allIds: typedData.map((document) => document.id)
									},
									approvals,
									clientApprovals,
									userPresence: Utility.normalize(),
									tasks,
									documentReviews,
									childrenDocuments,
									relatedCanvasForms
								}
							};
						}
						// CGT Canvas Forms document section: DocumentType 49, 80
						typedData = Object.values(data);
						typedData = typedData.filter((document) => document.documentTypeId !== documentTypes.EVIDENCE);
						if (typedData.length > 0) {
							result = {
								...result,
								[`${action.parentName}canvasforms`]: {
									...result[`${action.parentName}canvasforms`],
									filters,
									filterKey: `${action.parentName}canvasforms`,
									response: {
										data: typedData,
										page: action.response.page,
										pages: action.response.pages,
										totalEntityCount: action.response.totalEntityCount
									},
									documents: {
										allIds: typedData.map((document) => document.id)
									},
									approvals,
									clientApprovals,
									userPresence: Utility.normalize(),
									tasks,
									documentReviews,
									childrenDocuments,
									relatedCanvasForms
								}
							};
						}
					} else {
						result = {
							...state,
							[action.parentName]: {
								...state[action.parentName],
								filters,
								filterKey: action.filterKey ? action.filterKey : '',
								response: {
									data: data,
									page: action.response.page,
									pages: action.response.pages,
									totalEntityCount: action.response.totalEntityCount
								},
								documents: {
									allIds: action.response.data.map((document) => document.id)
								},
								approvals,
								clientApprovals,
								userPresence: Utility.normalize(),
								tasks,
								documentReviews,
								childrenDocuments,
								relatedCanvasForms
							}
						};
					}
					// There are no documents for this query
				} else {
					result = {
						...state,
						[action.parentName]: {
							...state[action.parentName],
							filters,
							filterKey: action.filterKey ? action.filterKey : '',
							response: {
								data: {},
								page: action.response.page,
								pages: action.response.pages,
								totalEntityCount: action.response.totalEntityCount
							},
							approvals: Utility.normalize(),
							clientApprovals: Utility.normalize(),
							documentReviews: Utility.normalize(),
							documents: Utility.normalize(),
							userPresence: Utility.normalize()
						}
					};
				}
				// Document upload is in progress and switching tabs and same document is present in other tab then do not show progress bar of exisitng doument and exclude document from documents list and keep only in upload list.
				if (
					result &&
					result[action.parentName] &&
					result[action.parentName].upload &&
					result[action.parentName].upload.allIds &&
					result[action.parentName].upload.allIds.length > 0
				) {
					let documents;
					let parentName = action.parentName;
					result[parentName].upload.allIds.forEach((uploadDocumentId) => {
						documents = result[parentName].documents.allIds.filter((documentId) => documentId !== uploadDocumentId);
					});
					result[parentName] = {
						...result[parentName],
						documents: {
							allIds: documents
						}
					};
				}
				return result;
			}

			return state;
		}
		case actions.SET_DOCUMENT_LIST_FILTERS: {
			let _state = {...state};

			if (action.filters.shared) {
				_state.filters = {
					[action.filterKey]: action.filters.shared
				};
			}

			return {
				..._state,
				[action.parentName]: {
					filters: action.filters,
					response: {
						refresh: true
					},
					upload: state[action.parentName]?.upload
				}
			};
		}

		case actions.MERGE_DOCUMENT_LIST_FILTERS: {
			let _state = {...state};

			if (action.filters.shared) {
				if (!_state.filters) {
					_state.filters = {[action.filterKey]: {}};
				}

				_state.filters[action.filterKey] = {
					...state.filters[action.filterKey],
					...action.filters.shared
				};

				delete action.filters.shared;
			}

			let filters = {...state[action.parentName].filters};
			Object.entries(action.filters).forEach((level) => {
				if (!filters) {
					filters = {};
				}

				if (level[1]) {
					filters[level[0]] = {
						...filters[level[0]],
						...level[1]
					};
				} else {
					delete filters[level[0]];
				}
			});

			let updateData = state[action.parentName]?.response?.data;
			let refresh = true;
			let ids = [];
			if (action.filters.specific.enableClientSorting && action.filters.specific.orderBy) {
				let arrayData = [];
				const result = Object.keys(updateData).map((key) => {
					arrayData.push(updateData[key]);
				});
				if (action.filters.specific.customSortFunction) {
					updateData = action.filters.specific.customSortFunction(
						arrayData,
						action.filters.specific.orderBy,
						action.filters.specific.orderByAscending,
						action.filters.specific.orderByColumnsList
					);
				} else {
					updateData = Utility.sortRowsData(
						arrayData,
						action.filters.specific.orderBy,
						action.filters.specific.orderByAscending,
						action.filters.specific.orderByColumnsList
					);
				}

				let data = {};
				for (let i = 0; i < updateData.length; i++) {
					data[updateData[i].id] = updateData[i];
				}

				ids = updateData.map((document) => document.id);
				updateData = data;
				refresh = false;
			}

			let newState = {
				..._state,
				[action.parentName]: {
					..._state[action.parentName],
					filters,
					response: {
						refresh: refresh,
						data: updateData
					},
					documents: {
						allIds: ids.length > 0 ? ids : state[action.parentName].documents?.allIds || []
					},
					upload: state[action.parentName]?.upload
				}
			};

			return newState;
		}

		case actions.SET_DOCUMENT_LIST_FILTER: {
			let value = action.value;
			if (!Utility.hasValue(value)) {
				// If filter is being disabled, explicit undefined is required
				value = null;
			}
			let filters;
			//	4. Shared filters 		Shared accross different DocumentList instances
			if (!action.parentName) {
				filters = {...state.filters};
				if (action.filterKey) {
					if (filters[action.filterKey]) {
						filters[action.filterKey] = {...filters[action.filterKey]};
					} else {
						filters[action.filterKey] = {};
					}

					filters[action.filterKey][action.filterItemName] = value;
				} else {
					filters[action.filterItemName] = value;
				}

				// Page number must be rest to zero to all active instances
				let result = {...state};

				Object.entries(result).forEach((item) => {
					if (item[0] !== 'filters' && item[1]?.response) {
						if (action.filterKey === item[1]?.filterKey) {
							let filters = {...state[item[0]].filters};
							if (!filters.specific) {
								filters.specific = {page: 1};
							} else {
								filters.specific = {...filters.specific, page: 1};
							}

							result[item[0]] = {
								filters,
								response: {
									refresh: true
								}
							};
						} else if (
							item[0] === documentTabLayoutTabs.myPinnedDocuments ||
							item[0] === documentTabLayoutTabs.teamPinnedDocuments
						) {
							let filters = {...state[item[0]].filters};
							if (!filters.specific) {
								filters.specific = {page: 1};
							} else {
								filters.specific = {...filters.specific, page: 1};
							}

							result[item[0]] = {
								filters,
								response: {
									refresh: true
								}
							};
						}
					}
				});

				return {
					...result,
					filters
				};

				//	5. Specific filters 	Specific to this DocumentList instance
			} else {
				let specific = {};
				if (state[action.parentName].filters.specific) {
					specific = {...state[action.parentName].filters.specific};
				}
				specific[action.filterItemName] = value;

				if (action.filterItemName !== 'page') {
					specific.page = 1;
				}

				return {
					...state,
					[action.parentName]: {
						filters: {
							...state[action.parentName].filters,
							specific
						},
						response: {
							refresh: true
						},
						upload: state[action.parentName].upload
					}
				};
			}
		}

		case actions.SET_DOCUMENT_LIST_ENTITY_VIEW: {
			return {
				...state,
				[action.parentName]: {
					filters: {
						...state[action.parentName]?.filters
					},
					response: {
						refresh: true,
						view: action.view
					},
					upload: state[action.parentName]?.upload
				}
			};
		}

		case actions.CLEAR_DOCUMENT_LIST_FILTERS: {
			let filters = {...state[action.parentName]?.filters};
			let shared;

			// Delete all filter levels up to Url filters, that is Specific, Shared, and Url and Session
			if (filters.specific) {
				filters.specific = {
					...filters.specific,
					orderBy: filters.specific.orderBy,
					orderByAscending: filters.specific.orderByAscending
				};
			}

			// If Url filters were defined, override them with undefined
			shared = clearFilterLevel(filters, action, shared, 'queryString');
			shared = clearFilterLevel(filters, action, shared, 'session');

			return {
				...state,

				// Shared delete is beign done here
				filters: shared,

				[action.parentName]: {
					filters,
					response: {
						refresh: action.refresh !== undefined ? action.refresh : true
					},
					upload: state[action.parentName]?.upload
				}
			};
		}

		case actions.REFRESH_DOCUMENT_LIST: {
			return {
				...state,
				...{
					[action.parentName]: {
						filters: state[action.parentName]?.filters,
						response: {
							refresh: true,
							resetPage: action.resetPage
						},
						upload: state[action.parentName]?.upload
					}
				}
			};
		}

		case actions.UPDATE_NOTES_COUNT: {
			if (action.payload && state[action.payload.parentName]) {
				return getUpdateNotesCount(state, action.payload);
			}

			break;
		}
		case actions.RESET_TASK_ATTRIBUTES: {
			if (action.payloadAttributes && action.payloadAttributes.clearDocumentList && !_.isEmpty(state)) {
				let updatedState = {...state};
				const taskId = action.payload.taskId;
				Object.keys(state).forEach((key) => {
					// Only clear slices for the task's document list instances (not the doc list page)
					if (key.includes(taskId)) {
						updatedState[key] = {
							filters: state[key]?.filters,
							response: {
								refresh:
									action.payloadAttributes.refresh !== undefined
										? action.payloadAttributes.refresh
										: state[key]?.refresh
							},
							upload: state[key]?.upload
						};
					}
				});

				return updatedState;
			}

			return state;
		}

		case actions.SET_TASK_DOCUMENT_TAB: {
			if (action.payload && action.payload.parentName) {
				if (state[action.payload.parentName]) {
					return {
						...state,
						[action.payload.parentName]: {
							/*...initializeDocumentListInstance(),*/
							filters: state[action.payload.parentName].filters,
							upload: state[action.payload.parentName].upload
						}
					};
				}
				return state;
			}
			return state;
		}

		case actions.CLEAR_DOCUMENT_LIST: {
			if (action.parentName) {
				if (state[action.parentName]) {
					return {
						...state,
						[action.parentName]: {
							filters: state[action.parentName].filters,
							response: {
								refresh: false
							},
							upload: state[action.parentName].upload
						}
					};
				}
				return state;
			} else {
				return initialstate.documentList;
			}
		}

		case actions.CLEAR_CUSTOM_FILTERS: {
			let customFilters = {...state[action.parentName].filters};

			// Delete all filter levels up to Url filters, that is Specific, Shared, and Url and Session
			delete customFilters.specific;

			if (customFilters['queryString']) {
				customFilters['queryString'] = null;
			}

			if (customFilters['session']) {
				customFilters['session'] = null;
			}

			return {
				...state,

				// Shared delete is beign done here
				filters: null,

				[action.parentName]: {
					filters: customFilters,
					response: {
						refresh: true
					},
					upload: state[action.parentName]?.upload
				}
			};
		}

		case actions.GET_DOCUMENT_BY_ID: {
			if (!_.isEmpty(action.response)) {
				if (action.fromUpdate) {
					Object.keys(state).forEach((key) => {
						if (typeof state[key] === 'object' && state[key]) {
							Object.keys(state[key]).forEach((objectKey) => {
								objectKey === 'filterKey' ? (action.parentName = key) : null;
							});
						}
					});
				}
				if (action.parentName && state[action.parentName]) {
					let document = {...action.response};
					Object.keys(document).forEach((key) => document[key] === null && delete document[key]);

					let tasks = document.tasks;
					let taskIds = action.response.tasks.map((task) => task.id);
					if (tasks) {
						if (action.filteredEntityIdGuid) {
							tasks = tasks.filter((task) => task.id !== action.filteredEntityIdGuid);
							taskIds = taskIds.filter((id) => id !== action.filteredEntityIdGuid);
						}
						tasks = Utility.normalize(tasks, _.cloneDeep(state[action.parentName].tasks));
						document.tasks = tasks.allIds;
						document.relatedTasksCount = taskIds.length;
					}

					let approvals;
					if (document.approvals) {
						approvals = Utility.normalize(document.approvals, _.cloneDeep(state[action.parentName].approvals));
						document.approvals = document.approvals.map((approval) => approval.id);
					}

					return {
						...state,
						[action.parentName]: {
							...state[action.parentName],
							response: {
								...state[action.parentName].response,
								data: {
									...state[action.parentName].response.data,
									[action.documentId]: {
										...state[action.parentName].response.data[action.documentId],
										...document,
										childrenDocuments: state[action.parentName].response.data[action.documentId]?.childrenDocuments,
										tasks: taskIds,
										signOffUsers: action.response.approvals
									}
								}
							},
							tasks,
							approvals
						}
					};
				} else {
					return state;
				}
			}
			return state;
		}
		case actions.GET_DOCUMENT_HISTORY: {
			if (action.response) {
				return {
					...state,
					[action.parentName]: {
						...state[action.parentName],
						currentDocument: action.response,
						documentVersions: Utility.normalize(action.response.documentVersions)
					}
				};
			}
			return state;
		}
		case actions.CLEAR_DOCUMENT_LIST_HISTORY: {
			return {
				...state,
				[action.parentName]: {
					...state[action.parentName],
					documentVersions: undefined
				}
			};
		}
		case actions.CLEAR_DOCUMENT_BY_ID:
		case actions.DELETE_DOCUMENT_BY_ID: {
			if (action.error) {
				return state;
			}

			if (action.parentName) {
				const result = {
					...state,
					[action.parentName]: {
						...state[action.parentName],
						response: {
							...state[action.parentName].response,
							data: {
								...state[action.parentName].response.data
							},
							totalEntityCount: state[action.parentName].documents.allIds.includes(action.documentId)
								? state[action.parentName].response.totalEntityCount - 1
								: state[action.parentName].response.totalEntityCount
						},
						documents: {
							allIds: [
								...state[action.parentName].documents.allIds.filter((documentId) => documentId !== action.documentId)
							]
						}
					}
				};
				delete result[action.parentName].response.data[action.documentId];
				return result;
			}

			return state;
		}

		case actions.ADD_DOCUMENT_TO_LIST: {
			return {
				...state,
				...{
					[action.parentName]: {
						...state[action.parentName],
						documents: {
							allIds: [action.document.id, ...state[action.parentName]?.documents.allIds]
						},
						response: {
							...state[action.parentName]?.response,
							data: {
								...state[action.parentName]?.response.data,
								[action.document.id]: {...action.document, selected: false}
							}
						}
					}
				}
			};
		}

		/* Is like CLEAR_DOCUMENT_LIST but here we also remove the upload property. */
		case actions.RESET_DOCUMENT_LIST: {
			if (action.parentName) {
				if (state[action.parentName]) {
					return {
						...state,
						[action.parentName]: {
							filters: state[action.parentName].filters
						}
					};
				}
				return state;
			} else {
				return state;
			}
		}

		case actions.UPDATE_DOCUMENT_LIST_BY_ID: {
			return {
				...state,
				[action.parentName]: {
					...state[action.parentName],
					response: {
						...state[action.parentName].response,
						data: {
							...state[action.parentName].response.data,
							[action.documentId]: {
								...state[action.parentName].response.data[action.documentId],
								...action.payload
							}
						}
					}
				}
			};
		}
		case actions.SELECT_DOCUMENT_LIST_BY_ID: {
			return {
				...state,
				[action.parentName]: {
					...state[action.parentName],
					response: {
						...state[action.parentName].response,
						data: {
							...state[action.parentName].response.data,
							[action.documentId]: {
								...state[action.parentName].response.data[action.documentId],
								selected: !state[action.parentName].response.data[action.documentId].selected
							}
						}
					},
					lastSelected: action.documentId
				}
			};
		}

		case actions.SELECT_DOCUMENT_LIST_BY_RANGE: {
			const selected = !state[action.parentName].response.data[action.documentId].selected;

			const from = state[action.parentName].documents.allIds.indexOf(state[action.parentName].lastSelected),
				to = state[action.parentName].documents.allIds.indexOf(action.documentId);

			const start = Math.min(from, to),
				end = Math.max(from, to);

			return {
				...state,
				[action.parentName]: {
					...state[action.parentName],
					response: {
						...state[action.parentName].response,
						data: Object.fromEntries(
							state[action.parentName].documents.allIds.map((documentId, index) => {
								const document = state[action.parentName].response.data[documentId];
								if (start <= index && index <= end) {
									return [documentId, {...document, selected}];
								}
								return [documentId, document];
							})
						)
					},
					lastSelected: action.documentId
				}
			};
		}

		case actions.UPDATE_DOCUMENT_LIST_BY_PARENTNAME: {
			const result = {
				...state,
				[action.parentName]: {
					...state[action.parentName],
					response: {
						...state[action.parentName].response,
						data: {
							...state[action.parentName].response.data
						}
					}
				}
			};

			for (const document of action.payload) {
				result[action.parentName].response.data[document.id] = {
					...result[action.parentName].response.data[document.id],
					...document
				};
			}

			return result;
		}

		case actions.ADD_APPROVAL_FOR_DOCUMENT: {
			if (
				action.response &&
				action.response.approvalId &&
				state[action.parentName] &&
				state[action.parentName].response &&
				state[action.parentName].response.data &&
				state[action.parentName].response.data[action.documentId]
			) {
				return {
					...state,
					[action.parentName]: {
						...state[action.parentName],
						response: {
							...state[action.parentName].response,
							data: {
								...state[action.parentName].response.data,
								[action.documentId]: {
									...state[action.parentName].response.data[action.documentId],
									approvals: [
										...state[action.parentName].response.data[action.documentId].approvals,
										action.response.approvalId
									]
								}
							}
						},
						approvals: {
							byId: {
								...state[action.parentName].approvals.byId,
								[action.response.approvalId]: {
									...action.response,
									id: action.response.approvalId,
									approvalUserName: action.response.name,
									approvalUserInititals: action.response.userInitials,
									clientSignoffJson: null
								}
							},
							allIds: [...state[action.parentName].approvals.allIds, action.response.approvalId]
						}
					}
				};
			}
			return state;
		}
		case actions.CREATE_SNAPSHOT: {
			return state;
		}
		case actions.REMOVE_APPROVAL_FOR_DOCUMENT: {
			if (
				state[action.parentName] &&
				state[action.parentName].response &&
				state[action.parentName].response.data &&
				state[action.parentName].response.data[action.documentId]
			) {
				return {
					...state,
					[action.parentName]: {
						...state[action.parentName],
						response: {
							...state[action.parentName].response,
							data: {
								...state[action.parentName].response.data,
								[action.documentId]: {
									...state[action.parentName].response.data[action.documentId],
									approvals: state[action.parentName].response.data[action.documentId].approvals.filter(
										(approvalId) => approvalId !== action.approvalId
									)
								}
							}
						},
						approvals: {
							byId: {
								...state[action.parentName].approvals.byId,
								[action.approvalId]: undefined
							},
							allIds: state[action.parentName].approvals.allIds.filter((approvalId) => approvalId !== action.approvalId)
						}
					}
				};
			}
			return state;
		}
		case actions.UNLINK_SHARED_DOCUMENT: {
			const parentName = Utility.getUniqueParentName({
				relatedEntityId: action.relatedEntityId,
				parentName: action.parentName
			});

			if (action.error && action.error.response) {
				return state;
			} else {
				return {
					...state,
					[parentName]: {
						...state[parentName],
						response: {
							...state[parentName].response,
							data: {
								...state[parentName].response.data,
								[action.payload.documentId]: {
									...state[parentName].response.data[action.payload.documentId],
									...{
										documentStatusId: DocumentStatus.UnlinkInProgress
									}
								}
							}
						}
					}
				};
			}
		}

		case actions.UNLINK_ALL_SHARED_DOCUMENTS: {
			return state;
		}

		//#region Document Helper actions
		case 'DOCHELPER_UPLOAD_DOCUMENT': {
			if (!action.isOnline && action.meta.docHelper) {
				return offloadDocumentUploadComplete(state, action.meta.docHelper.docPayload, action.response);
			} else {
				let docPayload = action.meta.docHelper.docPayload;

				if (!docPayload) {
					return state;
				}

				let result = {...state};
				const parentNames = [...new Set(docPayload.map((document) => document.parentName))];

				if (result.uploadFailed) {
					return {...result, uploadFailed: false};
				}

				parentNames.forEach((parentName) => {
					let upload;
					if (result[parentName]?.upload) {
						upload = {
							byId: {...result[parentName].upload.byId},
							allIds: [...result[parentName].upload.allIds]
						};
					} else {
						upload = Utility.normalize();
					}

					result[parentName] = {
						...result[parentName],
						upload: upload
					};
				});

				for (const document of docPayload) {
					const parentName = document.parentName;

					result[parentName].upload.byId[document.id] = {
						documentName: document.documentName,
						fileExt: document.fileExt,
						documentTypeId: document.documentType,
						engagementId: document.engagementId,

						// TODO: taskId should always be relatedEntityId
						relatedEntityId: document.relatedEntityId || document.taskId
					};

					result[parentName].upload.allIds.unshift(document.id);
				}

				return result;
			}
		}

		case actions.DOCHELPER_ERROR: {
			const newState = {...state, uploadFailed: true};
			return newState;
		}

		case 'ADD_DUPLICATE_DOCUMENT': {
			if (action.meta.document) {
				const documentId = action.meta.document.documentId;
				const payload = action.meta.document.payload;

				const parentName = payload.parentName;

				return {
					...state,
					[parentName]: {
						...state[parentName],
						upload: {
							byId: {
								...state[parentName].upload.byId,
								[documentId]: {
									...state[parentName].upload.byId[payload.id],
									id: documentId,
									isOverwrite: false
								},
								[payload.id]: undefined
							},
							allIds: state[parentName].upload.allIds.map((id) => (id === payload.id ? documentId : id))
						}
					}
				};
			}

			return state;
		}

		case 'SELECT_DOCUMENT_OVERWRITE': {
			const documentId = action.meta.documentId;

			const parentName = action.parentName;
			return {
				...state,
				[parentName]: {
					...state[parentName],
					upload: {
						...state[parentName].upload,
						byId: {
							...state[parentName].upload.byId,
							[documentId]: {
								...state[parentName].upload.byId[documentId],
								isOverwrite: action.meta.isOverwrite
							}
						}
					}
				}
			};
		}

		case 'CLEAR_DUPLICATE_DOCUMENTS': {
			if (action.payload && action.payload.length > 0) {
				const parentNames = [...new Set(action.payload.map((document) => document.parentName))];
				if (parentNames.length > 0) {
					let result = {...state};

					parentNames.forEach((parentName) => {
						let data = {...state[parentName]?.response?.data};
						let documents = [...(state[parentName]?.documents?.allIds ?? [])];
						let byId = {...state[parentName].upload.byId};
						let allIds = [...state[parentName].upload.allIds];

						state[parentName].upload.allIds.forEach((documentId) => {
							if (state[parentName].upload?.byId[documentId]?.isOverwrite) {
								delete data[documentId];
								documents = documents.filter((id) => id !== documentId);
							} else {
								delete byId[documentId];
								allIds = allIds.filter((id) => id !== documentId);
							}
						});

						result[parentName] = {
							...state[parentName],
							response: {
								...state[parentName].response,
								data: data
							},
							documents: {
								allIds: documents
							},
							upload: {
								byId: byId,
								allIds: allIds
							}
						};
					});

					return result;
				}
			}

			return state;
		}

		case 'DOCUMENT_UPLOAD_PROGRESS':
			if (action.meta.docHelper) {
				const payload = action.meta.docHelper.payload;
				const message = action.meta.docHelper.message;

				const parentName = payload.parentName;

				if (state[parentName]) {
					// This is the Id calculated with documentName becuase no documentId was calculated yet
					let documentId = message.FileName;

					let upload = initializeDocumentUpload(state, parentName);

					// payload.inProgress might be false if the file uploads too fast
					if (payload.inProgress) {
						// If a different documentId is detected, update it and use documentName a is of the previous state
						if (!upload.byId[payload.documentId]) {
							let document = state[parentName].upload?.byId[documentId];
							if (!document && message.FileName) {
								const split = message.FileName.split('.');
								const documentName = split[0];
								const fileExt = split[1];

								document = {
									documentName: documentName,
									fileExt: fileExt,
									documentTypeId: payload.documentType,
									engagementId: payload.engagementId,

									// TODO: taskId should always be relatedEntityId
									relatedEntityId: payload.relatedEntityId || payload.taskId
								};

								upload.allIds.unshift(message.FileId);
							} else {
								upload.byId[documentId] = undefined;
								upload.allIds = state[parentName].upload.allIds.map((id) =>
									id === documentId ? payload.documentId : id
								);
							}

							upload.byId[payload.documentId] = document;

							return {
								...state,
								[parentName]: {
									...state[parentName],
									upload: upload
								}
							};
						}
					} else {
						if (!upload.allIds.some((id) => id === documentId)) {
							documentId = payload.documentId;
						}

						return documentUploadComplete(state, payload, documentId, message, action);
					}
				}
			}
			return state;

		case 'DOCUMENT_UPLOAD_COMPLETE':
			if (action.meta.docHelper) {
				const payload = action.meta.docHelper.payload;
				const message = action.meta.docHelper.message;

				const parentName = payload.parentName;

				if (state[parentName]) {
					let documentId = payload.documentId;
					if (!state[parentName].upload?.byId[documentId]) {
						documentId = message.FileName;
					}

					return documentUploadComplete(state, payload, documentId, message, action);
				}
			}
			return state;
		//#endregion

		//#region Upchunk actions
		case 'UPCHUNK_CREATING_DOCUMENT_METADATA': {
			const [documentName, fileExt] = getFileNameAndExtension(action.fileName);

			const result = {
				...state,
				[action.parentName]: {
					...state[action.parentName]
				}
			};

			const upload = {
				byId: {
					[action.fileId]: {
						engagementId: action.engagementId,

						id: action.fileId,

						documentName: documentName,
						documentTypeId: action.documentTypeId,
						fileExt: fileExt,

						progressPercent: 0,
						totalPercentage: 100
					}
				},
				allIds: [action.fileId]
			};

			if (result[action.parentName].upload) {
				upload.byId = {
					...result[action.parentName].upload.byId,
					...upload.byId
				};
				upload.allIds = result[action.parentName].upload?.allIds?.concat(action.fileId);
			}

			return {
				...state,
				[action.parentName]: {
					...state[action.parentName],
					upload
				}
			};
		}

		case 'UPCHUNK_CREATE_DOCUMENT_METADATA': {
			if (!action.error) {
				const isOverwrite = action.meta.api.headers.isOverwrite;

				if (!isOverwrite || isOverwrite === 'false') {
					const document = action.response,
						documentId = document.id;

					const result = {
						...state,
						[action.parentName]: {
							...state[action.parentName],
							upload: {
								...state[action.parentName].upload,
								byId: {
									...state[action.parentName].upload.byId,
									[documentId]: {
										// Moving the old temporary Id to the response one
										...state[action.parentName].upload.byId[action.data.fileId],

										id: documentId
									}
								},
								allIds: state[action.parentName].upload.allIds.concat(documentId)
							}
						}
					};

					// Delete the temporary generated Id document
					delete result[action.parentName].upload.byId[action.data.fileId];
					result[action.parentName].upload.allIds = result[action.parentName].upload.allIds.filter(
						(value) => value !== action.data.fileId
					);

					return result;
				}
				return state;
			}
			return state;
		}

		case 'UPCHUNK_DOCUMENT_UPLOAD_PROGRESS': {
			const document = action.meta.upchunk.payload;

			return {
				...state,
				[action.parentName]: {
					...state[action.parentName],
					upload: {
						...state[action.parentName].upload,
						byId: {
							...state[action.parentName].upload?.byId,
							[document.documentId]: {
								...state[action.parentName].upload?.byId[document.documentId],
								progressPercent: document.progressPercent,
								totalPercentage: document.totalPercentage
							}
						}
					}
				}
			};
		}

		case 'UPCHUNK_COMPLETE_DOCUMENT_UPLOAD': {
			const result = {
				...state,
				[action.parentName]: {
					...state[action.parentName]
				}
			};
			const documentId = action.response.documentId;
			let document = state[action.parentName].upload?.byId[documentId];

			if (!document || !document.documentName) {
				document = state[action.parentName].response?.data[documentId];
			}

			if (result && document && documentId) {
				if (state[action.parentName].documents && state[action.parentName].documents.allIds) {
					if (!state[action.parentName].documents.allIds.includes(documentId)) {
						result[action.parentName].documents = {
							allIds: [documentId].concat(state[action.parentName].documents.allIds)
						};
					}

					result[action.parentName].response = {
						...state[action.parentName].response,
						data: {
							...state[action.parentName].response.data,
							[documentId]: {
								engagementId: document?.engagementId,
								id: documentId,
								documentName: document?.documentName,
								documentTypeId: document?.documentTypeId,
								fileExt: document?.fileExt,

								// Related entities that must be initialized
								approvals: [],
								engagementReviewNoteCount: 0,
								tasks: []
							}
						},
						totalEntityCount: state[action.parentName].response.totalEntityCount + 1
					};
				}

				const upload = {
					byId: {
						...state[action.parentName].upload?.byId
					},
					allIds: state[action.parentName].upload?.allIds?.filter((value) => value !== documentId)
				};

				if (upload && upload.allIds?.length > 0) {
					delete upload?.byId[documentId];
					result[action.parentName].upload = upload;
				} else {
					delete result[action.parentName].upload;
				}

				return result;
			}

			return state;
		}

		case 'UPCHUNK_UPLOAD_ERROR': {
			if (action.parentName) {
				const result = {
					...state,
					[action.parentName]: {
						...state[action.parentName],
						upload: {
							byId: {
								...state[action.parentName].upload.byId
							},
							allIds: state[action.parentName].upload.allIds.filter((value) => value !== action.meta.documentId)
						}
					}
				};

				delete result[action.parentName].upload.byId[action.meta.documentId];
				if (result[action.parentName].upload.allIds.length === 0) {
					delete result[action.parentName].upload;
				}

				return result;
			}
			//#endregion
		}

		case actions.DELETE_DOCUMENT_VERSION_BY_ID: {
			if (!action.error) {
				const result = {
					...state,
					[action.parentName]: {
						...state[action.parentName],
						currentDocument: {
							...state[action.parentName].currentDocument,
							documentVersions: state[action.parentName].currentDocument.documentVersions.filter(
								(value) => value.id !== action.documentVersionId
							)
						},
						documentVersions: {
							byId: {
								...state[action.parentName].documentVersions.byId
							},
							allIds: state[action.parentName].documentVersions.allIds.filter(
								(value) => value !== action.documentVersionId
							)
						}
					}
				};

				delete result[action.parentName].documentVersions.byId[action.documentVersionId];

				return result;
			}

			return state;
		}

		case actions.DELETE_DOCUMENT_REVIEW: {
			return {
				...state,
				[action.parentName]: {
					...state[action.parentName],
					response: {
						...state[action.parentName].response,
						data: {
							...state[action.parentName].response.data,
							[action.documentId]: {
								...state[action.parentName].response.data[action.documentId],
								documentReviews: state[action.parentName].response.data[action.documentId].documentReviews.filter(
									(reviewId) => reviewId !== action.reviewId
								)
							}
						}
					},
					documentReviews: {
						byId: {
							...state[action.parentName].documentReviews.byId,
							[action.reviewId]: undefined
						},
						allIds: state[action.parentName].documentReviews.allIds.filter((reviewId) => reviewId !== action.reviewId)
					}
				}
			};
		}
		case actions.CREATE_DOCUMENT_REVIEW: {
			if (action.response && action.response.id) {
				return {
					...state,
					[action.parentName]: {
						...state[action.parentName],
						response: {
							...state[action.parentName].response,
							data: {
								...state[action.parentName].response.data,
								[action.documentId]: {
									...state[action.parentName].response.data[action.documentId],
									documentReviews: [
										...state[action.parentName].response.data[action.documentId].documentReviews,
										action.response.id
									]
								}
							}
						},
						documentReviews: {
							byId: {
								...state[action.parentName].documentReviews.byId,
								[action.response.id]: {
									id: action.response.id,
									approvalUserId: action.response.approvalUserId,
									approvalDate: action.response.approvalDate,
									approvalUserName: action.response.approvalUserName,
									approvalUserInitials: action.response.approvalUserInitials,
									documentId: action.documentId
								}
							},
							allIds: [...state[action.parentName].documentReviews.allIds, action.response.id]
						}
					}
				};
			}
			return state;
		}
		case actions.ASSOCIATE_TASK_DOCUMENTS: {
			// TaskDocument delete API returns No content so check for empty string as well.
			if ((action.response || action.response === '') && !action.error) {
				let documents = {
					allIds: []
				};

				const apiData = action.meta?.api?.data;
				let taskId =
					apiData.taskId || apiData.TaskId || (apiData.taskIds && apiData.taskIds.length > 0 && apiData.taskIds[0]);

				const parentName =
					apiData.parentName?.indexOf('_') > -1
						? apiData.parentName
						: action.parentName?.indexOf('_') > -1
						? action.parentName
						: Utility.getUniqueParentName({
								relatedEntityId: taskId,
								parentName: apiData.parentName
						  });

				if (state[parentName] && state[parentName].response) {
					// Assigning the first truthy value, because documentId may come from any of these places
					const documentId = action.response.documentId || apiData?.DocumentId || apiData?.documentId;

					if (apiData.operationType === 1 || action.operationType === 1) {
						//Check if doc is already Added
						let notesCount = undefined;
						let newApprovals = [];
						if (action.response.approvals) {
							newApprovals = [...action.response.approvals];
						}
						if (
							action.payload &&
							action.payload.functionType &&
							action.payload.functionType.toUpperCase() === 'RELATE'
						) {
							// Notescount component calls api to get notes count if engagementReviewNoteCount is undefined but if we relate document then we don't need to call NotesCount api
							notesCount = 0;
						}

						let docName =
							action.response.documentName ||
							apiData?.DocumentName ||
							apiData?.documentName ||
							getFileName(action.documentName);

						let docExtension =
							action.response.fileExt ||
							apiData?.Documentfileext ||
							apiData?.documentfileext ||
							action.documentfileext ||
							getFileExtension(action.documentName, false);

						let stateDocument = state[parentName].response?.data[documentId];

						let newDoc = {
							id: documentId,
							documentName: docName,
							fileExt: docExtension,
							documentTypeId:
								action.response.documentTypeId ||
								apiData?.DocumentTypeId ||
								apiData?.documentTypeId ||
								apiData?.targetDocumentTypeId,
							engagementId:
								stateDocument?.engagementId ||
								action.response.engagementId ||
								apiData?.EngagementId ||
								apiData?.engagementId,
							relatedEntityId: stateDocument?.relatedEntityId ?? taskId,
							signOffUsers: stateDocument?.signOffUsers ?? newApprovals,
							engagementReviewNoteCount: stateDocument?.engagementReviewNoteCount || notesCount || 0,
							gaComponentDocumentStatusID:
								stateDocument?.gaComponentDocumentStatusID ??
								(!action.response.hasOwnProperty('gaComponentDocumentStatusID')
									? null
									: action.response.gaComponentDocumentStatusID),
							approvals: stateDocument?.approvals ?? (newApprovals && newApprovals.map((approval) => approval.id))
						};

						let parentApproval = {...state[parentName].approvals};
						let filterApproval = Utility.normalize(
							newApprovals,
							parentApproval.allIds ? parentApproval : {byId: {}, allIds: []}
						);

						let response = {
							...state[parentName].response,
							data: {
								...state[parentName].response.data,
								[documentId]: {...state[parentName].response.data[documentId], ...newDoc}
							}
						};

						if (state[parentName].documents) {
							documents.allIds = [...state[parentName].documents.allIds];
						}

						if (documentId && documents.allIds && documents.allIds.indexOf(documentId) === -1) {
							documents.allIds.unshift(documentId);
						}

						return {
							...state,
							[parentName]: {
								...state[parentName],
								response: response,
								documents: documents,
								approvals: filterApproval
							}
						};
					}
					// Remove the association from task
					else {
						var data = {...state[parentName].response.data};
						delete data[documentId];
						var newDocs = [...state[parentName].documents.allIds].filter(function(item) {
							return item !== documentId;
						});

						let docResponse = {
							...state[parentName].response,
							data: data
						};

						return {
							...state,
							[parentName]: {
								...state[parentName],
								response: docResponse,
								documents: {
									...state[parentName].documents,
									allIds: newDocs
								}
							}
						};
					}
				}
			}
			return state;
		}
		case actions.UPDATE_DOCUMENT_METADATA: {
			if (action.payload && action.payload.operationType === 'RefreshTaskDocument' && !action.error) {
				let documents = {
					allIds: []
				};
				const parentName = Utility.getUniqueParentName({
					relatedEntityId: action.payload.relatedEntityId,
					parentName: action.payload.parentName
				});

				// Remove the association from task
				if (state[parentName] && state[parentName].response) {
					let data = {...state[parentName].response.data};
					let newDocs = [...state[parentName].documents.allIds].filter(function(item) {
						return item !== action.payload.documentId;
					});

					let docResponse = {
						...state[parentName].response,
						data: data
					};

					return {
						...state,
						[parentName]: {
							...state[parentName],
							response: docResponse,
							documents: {
								...state[parentName].documents,
								allIds: newDocs
							}
						}
					};
				}
			}
			return state;
		}
		case actions.GET_DOCUMENT_RELATED_TASKS: {
			if (action.response) {
				const parentName = action.parentName,
					documentId = action.documentId;

				const taskList =
					action.response.taskGroups && action.response.taskGroups.length > 0
						? action.response.taskGroups[0].tasks
						: [];

				const normalizedTasks = Utility.normalize(taskList, undefined, 'id');

				const result = {
					...state,
					[parentName]: {
						...state[parentName],
						response: {
							...state[parentName].response,
							data: {
								...state[parentName].response.data,
								[documentId]: {
									...state[parentName].response.data[documentId],
									otherTasks: normalizedTasks.allIds
								}
							}
						},
						otherTasks: normalizedTasks
					}
				};

				return result;
			}
			return state;
		}
		case actions.CHECK_IN_CHECK_OUT_DOCUMENT: {
			if (action?.responseObj?.data) {
				var docStatusId =
					action.responseObj.data?.versions &&
					action.responseObj.data.versions.length > 0 &&
					action.responseObj.data.versions.find((version) => version?.isCurrentVersion === true)?.documentStatusId;

				return {
					...state,
					[action.parentName]: {
						...state[action.parentName],
						response: {
							...state[action.parentName].response,
							data: {
								...state[action.parentName].response.data,
								[action.documentId]: {
									...state[action.parentName].response.data[action.documentId],
									documentStatusId: docStatusId
								}
							}
						}
					}
				};
			}
			return state;
		}

		case 'API_ERROR':
			return {
				...state,
				errors: {
					api_error: action.error
				}
			};
		default:
			return state;
	}
}

function clearFilterLevel(filters, action, shared, level) {
	if (filters[level]) {
		Object.keys(filters[level]).forEach((filter) => {
			if (action.filterState && action.filterState[filter]?.appliesTo?.some((item) => item === action.parentName)) {
				if (!filters.specific) {
					filters.specific = {};
				}

				filters.specific[filter] = null;
			} else {
				if (!shared) {
					shared = {
						[action.filterKey]: {[filter]: {}}
					};
				}
				if ((shared[action.filterKey] && shared[action.filterKey][filter]) || filters.queryString[filter]) {
					shared[action.filterKey][filter] = null;
				}
			}
		});
	}
	return shared;
}

function initializeDocumentUpload(state, parentName) {
	let upload;
	if (state[parentName].upload) {
		upload = {
			byId: {...state[parentName].upload.byId},
			allIds: [...state[parentName].upload.allIds]
		};
	} else {
		upload = Utility.normalize();
	}
	return upload;
}

function offloadDocumentUploadComplete(state, payloads, response) {
	let documents = {
		allIds: []
	};
	let docData = {};
	const parentName = payloads[0].parentName;

	// If user's still standing in the current parent, there must be a response so an update is needed
	if (state[parentName]?.response) {
		if (state[parentName].response.data) {
			docData = {...state[parentName].response.data};
		}
		documents = state[parentName].documents && {
			allIds: [...state[parentName].documents.allIds]
		};

		// If document was not found in upload node, it's because DOCHELPER_UPLOAD_DOCUMENT action did not dispatch successfuly
		payloads.map((item, index) => {
			let newDoc = {
				id: response[index].DocumentTransactionId,
				documentName: item.documentName,
				fileExt: item.fileExt,
				documentTypeId: item.documentType,
				engagementId: item.engagementId,

				// TODO: taskId should always be relatedEntityId
				relatedEntityId: item.taskId,
				engagementReviewNoteCount: 0,
				approvals: [],
				gaComponentDocumentStatusID: null
			};
			docData = {...docData, [response[index].DocumentTransactionId]: newDoc};

			documents.allIds && documents.allIds.unshift(response[index].DocumentTransactionId);
		});
	}
	let docResponse = {
		...state[parentName].response,
		data: docData,
		totalEntityCount: state[parentName].response.totalEntityCount + payloads.length
	};
	return {
		...state,
		[parentName]: {
			...state[parentName],
			response: docResponse,
			documents: documents
		}
	};
}

function getUpdateNotesCount(state, payload) {
	let updatedState = state;
	let stateUpdate = false;
	if (state[payload.parentName] && state[payload.parentName].response && state[payload.parentName].response.data) {
		let data = state[payload.parentName].response.data;
		Object.keys(payload.notesCount).forEach((key) => {
			let docUpdate = payload.notesCount[key];
			if (data[docUpdate.documentId] && data[docUpdate.documentId].engagementReviewNoteCount !== docUpdate.notesCount) {
				stateUpdate = true;
				updatedState = {
					...updatedState,
					[payload.parentName]: {
						...updatedState[payload.parentName],
						response: {
							...updatedState[payload.parentName].response,
							data: {
								...updatedState[payload.parentName].response.data,
								[docUpdate.documentId]: {
									...updatedState[payload.parentName].response.data[docUpdate.documentId],
									engagementReviewNoteCount: docUpdate.notesCount
								}
							}
						}
					}
				};
			}
		});
	}

	if (stateUpdate) {
		return updatedState;
	}

	return state;
}

function documentUploadComplete(state, payload, documentId, message, action) {
	let response;
	let documents;

	const parentName = payload.parentName || action.parentName;

	// If user's still standing in the current parent, there must be a response so an update is needed
	if (state[parentName] && state[parentName].response) {
		let totalCount;
		// If document is not in response node it still needs to be added
		if (state[parentName].response.data && !state[parentName].response.data[payload.documentId]) {
			// If documentId is passed, this is the temporary id that docHelper generated and needs to be replaced
			if (!documentId) {
				documentId = payload.documentId;
			}

			documents = {
				allIds: []
			};

			// If document was not found in upload node, it's because DOCHELPER_UPLOAD_DOCUMENT action did not dispatch successfuly
			let document =
				state[parentName].upload && state[parentName].upload.byId[documentId]
					? {...state[parentName].upload.byId[documentId]}
					: undefined;

			if (document) {
				document.id = payload.documentId;
				document.documentChangeTypeId = payload.documentChangeTypeId;
				document.taskId = payload.relatedEntityId || payload.taskId;
				document.relatedEntityId = payload.relatedEntityId || payload.taskId;
				document.engagementReviewNoteCount = 0;
				(document.gaComponentDocumentStatusID = !document.hasOwnProperty('gaComponentDocumentStatusID')
					? null
					: document.gaComponentDocumentStatusID),
					(document.approvals = []);
			} else {
				const split = message.FileName.split('.');
				const documentName = split[0];
				let fileExt;
				if (split[1]) {
					fileExt = split[1];
				}

				document = {
					id: payload.documentId || documentId,
					documentName: documentName,
					fileExt: fileExt,
					documentTypeId: payload.documentType,
					documentChangeTypeId: payload.documentChangeTypeId,
					engagementId: payload.engagementId,

					// TODO: taskId should always be relatedEntityId
					taskId: payload.relatedEntityId || payload.taskId,
					relatedEntityId: payload.relatedEntityId || payload.taskId,
					engagementReviewNoteCount: 0,
					gaComponentDocumentStatusID: !payload.hasOwnProperty('gaComponentDocumentStatusID')
						? null
						: payload.gaComponentDocumentStatusID,
					approvals: [],
					tasks: []
				};
			}

			totalCount = document.isOverwrite
				? state[parentName].response.totalEntityCount
				: state[parentName].response.totalEntityCount + 1;

			response = {
				...state[parentName].response,
				data: {
					...state[parentName].response.data,
					[payload.documentId || documentId]: document
				},
				totalEntityCount: totalCount
			};

			if (state[parentName].documents) {
				documents.allIds = [...state[parentName].documents.allIds];
			}

			documents.allIds && documents.allIds.unshift(payload.documentId || documentId);

			if (action && action.meta.docHelper && action.meta.docHelper.payload) {
				// access this property in taskdocumentsreducer to update taskdetail document list tab count and sync on same time and in same event
				action.meta.docHelper.payload[`${parentName}Count`] = documents.allIds.length;
			}

			// upload node wont be availbe for offline.
			if (state[parentName].upload) {
				return {
					...state,
					[parentName]: {
						...state[parentName],
						response: response,
						documents: documents,

						// Upload node must be updated regardless if the user is standing in the current parent or not
						upload: {
							byId: {
								...state[parentName].upload.byId,
								[documentId]: undefined
							},
							allIds: state[parentName].upload.allIds.filter((id) => id !== documentId)
						}
					}
				};
			} else {
				return {
					...state,
					[parentName]: {
						...state[parentName],
						response: response,
						documents: documents
					}
				};
			}
		} else if (state[parentName]?.upload) {
			return {
				...state,
				[parentName]: {
					...state[parentName],
					upload: {
						byId: {
							...state[parentName].upload.byId,
							[documentId]: undefined
						},
						allIds: state[parentName].upload.allIds.filter((id) => id !== documentId)
					}
				}
			};
		}
	}
	// in case of document upload is in progress and switching tabs then maintain upload progress for that documents.
	else if (state[parentName] && state[parentName].upload && state[parentName].upload.allIds.length > 0) {
		return {
			...state,
			[parentName]: {
				...state[parentName],

				// Remove documentId from allIds in case of document upload is in progress and switch the tab.
				upload: {
					byId: state[parentName].upload.byId,
					allIds: state[parentName].upload.allIds.filter((id) => id !== documentId)
				}
			}
		};
	}

	return state;
}
